import { EventTypeBackend, EventUnion } from '../../types/events.types';

export const getEventTransactionDate = (event: EventUnion) => {
  const defaultDate = event.createdAt;
  switch (event.type) {
    case EventTypeBackend.EXERCISE:
      return event.createdAt;
    case EventTypeBackend.EXPIRE:
    case EventTypeBackend.PAYOUT:
      return event.exercise?.items?.[0]?.date ?? event.createdAt;
    case EventTypeBackend.FUNDRAISING_ROUND:
    case EventTypeBackend.SAFE_CONVERSION:
    case EventTypeBackend.SHARE_ISSUANCE:
    case EventTypeBackend.VALUATION:
      return event.date;

    case EventTypeBackend.GRANT:
      return event.createdAt;

    case EventTypeBackend.NEW_PLAN:
      return event.sharePlan.date;

    case EventTypeBackend.NEW_POOL:
      return event.pool.date;

    case EventTypeBackend.POOL_DECREASE:
    case EventTypeBackend.POOL_INCREASE:
      return event.poolAdjustment.date;

    case EventTypeBackend.SAFE:
      return event.issueDate;

    default:
      return defaultDate;
  }
};
